export enum NavMode {
    DEFAULT = "default",
    COLLAPSED = "collapsed",
    COLLAPSED_OPEN = "collapsed-open",
    COMPACT = "compact",
    LEADS = "leads"
}